export const FETCH_ORDER_REQUEST = "FETCH_ORDER_REQUEST"
export const FETCH_ORDER_SUCCESS = "FETCH_ORDER_SUCCESS"
export const FETCH_ORDER_FAILURE = "FETCH_ORDER_FAILURE"